import {AbstractEntity} from "../abstract-entity.model";
import {SimpleEntity} from "../simple-entity.model";

export class WhTransferOrderProductModel extends AbstractEntity{
  whProduct: SimpleEntity;
  quantity: number;
  barcode: string;
  boxBarcode: string;
}
